import { useEffect, useState } from "react";
import axios from "axios";
function GetRefereeResponse() {
    const BASE_URL = window.location.hostname === 'localhost' ? "http://localhost:8000" : "https://dlqw5ngx5xpnk.cloudfront.net";

    const [status, setStatus] = useState("Verifying your response...");

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const appId = urlParams.get('appId');
        const ref = urlParams.get('ref');
        const ref_id = urlParams.get('ref_id');
        const response = urlParams.get('response');

        if (appId && ref && response) {
            axios.get(`${BASE_URL}/api/auth/referee-response`, {
                params: { appId, ref, ref_id, response }
            })
                .then(res => {
                    setStatus(res.data || "Your response has been recorded. Thank you!");
                    // setTimeout(() => window.close(), 3000);
                })
                .catch(err => {
                    setStatus('Error submitting response');
                });
        } else {
            setStatus('Missing required parameters.');
        }
    }, []);

    return (
        <div
            style={{
                textAlign: "center",
                marginTop: "50px",
                fontSize: "1.2rem",
            }}
        >
            {status}
        </div>
    );
}

export default GetRefereeResponse;